export default __webpack_public_path__ + "static/media/lock-red.60ce38a8.svg";